import {z} from 'zod';

import i18n from '@dms/i18n';

const MULO_MAX_LENGTH = 10;

export const WorkshopMeasurementUnitFormSchema = z.object({
  authorizationProfileId: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .trim()
    .min(1, i18n.t('general.validations.fieldIsRequired')),
  mulo: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .trim()
    .min(1, i18n.t('general.validations.fieldIsRequired'))
    .max(MULO_MAX_LENGTH),
  conversionRatio: z.number(),
});

export type WorkshopMeasurementUnitForm = z.infer<typeof WorkshopMeasurementUnitFormSchema>;
